"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMfaApi = void 0;
var _react = require("@reduxjs/toolkit/query/react");
var _objects = require("../utilities/objects");
const createMfaApi = _ref => {
  let {
    baseUrl,
    slice
  } = _ref;
  return (0, _react.createApi)({
    reducerPath: 'mfaApi',
    baseQuery: (0, _react.fetchBaseQuery)({
      baseUrl,
      credentials: 'include',
      prepareHeaders: (headers, _ref2) => {
        let {
          getState
        } = _ref2;
        const {
          accessToken,
          // Login token
          adminRole,
          asicsId,
          userToken,
          // MFA token
          userTokenExpires
        } = getState()[slice];
        const isAuthed = Boolean(adminRole) && Boolean(asicsId) && Boolean(userToken) && Date.now() < userTokenExpires;
        if (accessToken || userToken) {
          headers.set('Authorization', `Bearer ${isAuthed ? userToken : accessToken}`);
        }
        return headers;
      }
    }),
    endpoints: builder => ({
      get2faStatus: builder.mutation({
        query: () => ({
          method: 'POST',
          url: '/two-factor/setup'
        }),
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      confirm2fa: builder.mutation({
        query: _ref3 => {
          let {
            authCode
          } = _ref3;
          return {
            body: {
              passcode: authCode
            },
            method: 'POST',
            url: '/two-factor/login'
          };
        },
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      reset2fa: builder.mutation({
        query: _ref4 => {
          let {
            asicsId
          } = _ref4;
          return {
            method: 'DELETE',
            url: `/two-factor/${asicsId}`
          };
        },
        transformResponse: response => (0, _objects.toCamelCase)(response)
      })
    })
  });
};
exports.createMfaApi = createMfaApi;